export default {
  viewstateId: 'vs',
  nodeIds: 'n',
  similarReactionBaseId: 'srb',
  similarReactionIndex: 'sri',
  reactionProductToReplace: 'rep',
  itemsChunkSize: 'size',
  sorting: 'sort',
  targetFilter: 'target_filter',
  resultRange: 'score',
  reactionCountRange: 'n_react',
  priceRange: 'price',
  status: 'status',
  text: 'text',
  pricing: 'pricing',
  // we're keeping this for backward compatibility. :(
  // TODO: change to 'comma' when detailed view is ready
  0: '0',
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9',
  10: '10',
  11: '11',
  12: '12',
  13: '13',
  14: '14',
  15: '15',
  16: '16',
  17: '17',
  18: '18',
  19: '19',
  20: '20',
};
